import { all, takeLatest, fork, call, put } from "redux-saga/effects";
import actions from "./actions";
import { contentService } from "@iso/services";

export function* createContent() {
  yield takeLatest(actions.ADD_CONTENT_REQUEST, function* ({ payload }) {
    const { data, resolve, reject } = payload;
    try {
      const response = yield call(contentService.createContent, { ...data });
      yield put({
        type: actions.ADD_CONTENT_SUCCESS,
      });
      yield resolve(response);
    } catch (e) {
      yield put({ type: actions.ADD_CONTENT_ERROR });
      reject(e);
    }
  });
}

export function* getContent() {
  yield takeLatest(actions.GET_CONTENT_REQUEST, function* ({ payload }) {
    const { contentId, resolve, reject } = payload;
    try {
      const content = yield call(contentService.getContent, contentId);
      yield put({
        type: actions.GET_CONTENT_SUCCESS,
        content,
      });
      if (resolve) {
        yield resolve(content);
      }
    } catch (e) {
      yield put({ type: actions.GET_CONTENT_ERROR });
      if (reject) {
        reject(e);
      }
    }
  });
}

export function* updateContent() {
  yield takeLatest(actions.UPDATE_CONTENT_REQUEST, function* ({ payload }) {
    const { contentId, data, resolve, reject } = payload;
    try {
      const response = yield call(contentService.updateContent, contentId, { ...data });
      yield put({
        type: actions.UPDATE_CONTENT_SUCCESS,
      });
      yield resolve(response);
    } catch (e) {
      yield put({ type: actions.UPDATE_CONTENT_ERROR });
      reject(e);
    }
  });
}

export function* deleteContent() {
  yield takeLatest(actions.DELETE_CONTENT_REQUEST, function* ({ payload }) {
    const { contentId, resolve, reject } = payload;
    try {
      yield call(contentService.deleteContent, contentId);
      yield put({ type: actions.DELETE_CONTENT_SUCCESS });
      if (resolve) {
        yield resolve();
      }
    } catch (e) {
      yield put({ type: actions.DELETE_CONTENT_ERROR });
      if (reject) {
        reject(e);
      }
    }
  });
}

export function* resumeContent() {
  yield takeLatest(actions.RESUME_CONTENT_REQUEST, function* ({ payload }) {
    const { contentId, resolve, reject } = payload;
    try {
      yield call(contentService.resumeContent, contentId);
      yield put({ type: actions.RESUME_CONTENT_SUCCESS });
      if (resolve) {
        yield resolve();
      }
    } catch (e) {
      yield put({ type: actions.RESUME_CONTENT_ERROR });
      if (reject) {
        reject(e);
      }
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createContent),
    fork(getContent),
    fork(updateContent),
    fork(deleteContent),
    fork(resumeContent),
  ]);
}
